import React from 'react'
import { Row, Col, Tag } from 'antd'
import PropTypes from 'prop-types'

export default function ArticleTags({ tags }) {
  if (!tags) return null

  return (
    <Row gutter={[0, 16]}>
      <Col span={23}>
        {'Tagged With: '}
        {tags.map((tag, i) => (
          <Tag key={i} color="blue">
            {tag}
          </Tag>
        ))}
      </Col>
    </Row>
  )
}

ArticleTags.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.string),
}

ArticleTags.defaultProps = {
  tags: [],
}
